import React from "react";
import {useSelector} from "react-redux";
import {useDropzone} from "react-dropzone";
import makeStyles from "@material-ui/styles/makeStyles";
import {Typography} from "@material-ui/core";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";

const useStyles = makeStyles(() => ({
    container: {
        border: '2px dashed #eeeeee',
        borderRadius: '2px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
}));
const DropzoneComponent = (props) => {
    const {component} = props;
    const classes = useStyles();
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(component.properties.label, userLanguage)
    const {getRootProps, getInputProps} = useDropzone({
        disabled: true
    })

    return (
        <section className={classes.container} style={{
            width: '100%',
            height: '100%'
        }}>
            <div {...getRootProps()}>
                <input {...getInputProps()}/>
                <Typography color={'textSecondary'}>{multiLanguageLabel}</Typography>
            </div>
        </section>
    )
}
export default DropzoneComponent